/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsScheduleRecommendation extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsScheduleRecommendation");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsScheduleRecommendation.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsScheduleRecommendation>): AdditionalResourceDetailsForFinopsScheduleRecommendation {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsScheduleRecommendation(), model);
        AdditionalResourceDetailsForFinopsScheduleRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsScheduleRecommendation>): AdditionalResourceDetailsForFinopsScheduleRecommendation {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsScheduleRecommendation.newInstance(<AdditionalResourceDetailsForFinopsScheduleRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsScheduleRecommendation) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsScheduleRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsScheduleRecommendation): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsScheduleRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.schedule_timings) {
            for (let val of this.schedule_timings) {
                models.ScheduleRecommendationTiming.fixupPrototype(val);
            }
        }
    }

    /**
     * Schedule Finding Type
     */
    schedule_finding: models.ScheduleFinding;

    /**
     * Status of the schedule recommendation.
     */
    schedule_status: models.ScheduleResourceRecommendationStatus;

    /**
     * Schedule windows recommended for this resource
     */
    schedule_timings: Array<models.ScheduleRecommendationTiming>;

    /**
     * Source Recommendation Id
     */
    source_recommendation_id: string;

}
